import { useState } from 'react';
import {
  GetNavigationLinkGroupResponseModel,
  GetNavigationLinkGroupsFilterModel,
  ResponseModel,
} from '@picsart/growth-rc/FooterRelevantLinks';
import useMount from '@picsart/rc/useMount';
import trim from '@picsart/growth-rc/trim';

import { footerRelevantLinksType } from '../../../components/common/FooterRelevantLinks/types';
import { IToolData, RelevantLinksAPI } from '../../../data/tools';
import { SingleToolCard } from '../SingleToolCard';

import { data_test_id, title } from './data';
import useStyles from './styles';

export default function FooterRelevantLinks({
  links,
  analytics,
  pageName,
}: footerRelevantLinksType) {
  const classes = useStyles();
  const [relevantLinks, setRelevantLinks] = useState<Array<IToolData>>(links || []);

  useMount(() => {
    if (window?.location) {
      let pathName = trim(window.location.pathname || '', '/');
      pathName = pathName ? `${pathName}/` : '';
      const filter: GetNavigationLinkGroupsFilterModel = {
        sourceUrl: `${window.location.origin || ''}/${pathName}`,
        take: 10,
      };

      fetch(RelevantLinksAPI, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(filter),
      })
        .then((response) => response.json())
        .then((result: ResponseModel<GetNavigationLinkGroupResponseModel[]>) => {
          if (result?.response?.length > 0) {
            setRelevantLinks(
              result.response
                .flatMap((x) => x.targets)
                .slice(0, 10)
                .map((item) => {
                  return {
                    name: item.anchor,
                    href: item.targetUrl,
                    id: item.anchor,
                  };
                }),
            ); // slice because of max len is 10
          }
        })
        .catch(console.error);
    }
  });

  const onClick = (id: string, component: string) => {
    analytics.toolSelect({
      page_name: pageName,
      action_type: id,
      component,
    });
  };

  return relevantLinks.length > 0 ? (
    <section className={classes.wrapper} data-testid={data_test_id}>
      <div className={classes.rootContainer}>
        {relevantLinks.length > 0 && <h4 className={classes.smallHeading}>{title}</h4>}
        <div className={classes.list}>
          {relevantLinks.map(({ name, href, id }) => (
            <SingleToolCard
              key={id}
              onClick={() => onClick(id, 'footer-related-links')}
              href={href}
              name={name}
            />
          ))}
        </div>
      </div>
    </section>
  ) : null;
}
